import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { lookupsJson } from '@ourbranch/lookups';

import Field from 'core/components/form/form.v2';
import { BrandFormField } from 'common/components/farm/brand-form-field';
import useStyles from './mobile-home-renters-form.styles';

const numFamiliesInDwellingOptions = lookupsJson.numFamiliesInDwelling;
const roofTypeOptions = lookupsJson.farm.mobileHomeRoofType;
const tieDownTypeOptions = lookupsJson.farm.tieDownTypes;

const MobileHomeRentersForm = ({ basePath, disableRiskForm }) => {
  const classes = useStyles();

  return (
    <>
      <Field
        xs={6}
        type="select"
        options={numFamiliesInDwellingOptions}
        id={`${basePath}.building.numFamiliesInDwelling`}
        name={`${basePath}.building.numFamiliesInDwelling`}
        mode="light"
        label="Families in dwelling"
        disabled={disableRiskForm}
      />
      <Field
        xs={6}
        id={`${basePath}.building.roofType`}
        name={`${basePath}.building.roofType`}
        type="select"
        options={roofTypeOptions}
        mode="light"
        label="Roof type"
        disabled={disableRiskForm}
      />
      <Field
        xs={6}
        type="select"
        id={`${basePath}.building.tieDownType`}
        name={`${basePath}.building.tieDownType`}
        mode="light"
        label="Tie down type"
        options={tieDownTypeOptions}
        disabled={disableRiskForm}
      />
      <Grid item xs={6} className={classes.checkboxGridItem}>
        <Field
          name={`${basePath}.building.enclosedMasonryFoundation`}
          id={`${basePath}.building.enclosedMasonryFoundation`}
          type="checkbox"
          label="Enclosed masonry foundation?"
          mode="light"
          className={classes.checkboxContainer}
          disabled={disableRiskForm}
        />
      </Grid>
      <Grid item xs={6} className={classes.checkboxGridItem}>
        <Field
          name={`${basePath}.building.fullSkirtingAroundBase`}
          id={`${basePath}.building.fullSkirtingAroundBase`}
          type="checkbox"
          label="Is there a full skirting around the base?"
          mode="light"
          className={classes.checkboxContainer}
          disabled={disableRiskForm}
        />
      </Grid>
      <Grid item xs={6} className={classes.checkboxGridItem}>
        <BrandFormField
          name={`${basePath}.connectedHome.internetMonitoring`}
          id={`${basePath}.connectedHome.internetMonitoring`}
          type="checkbox"
          label="Internet connected monitoring device(s)?"
          mode="light"
          disabled={disableRiskForm}
        />
      </Grid>
    </>
  );
};

MobileHomeRentersForm.propTypes = {
  basePath: PropTypes.string.isRequired
};

export default MobileHomeRentersForm;
